import { pinCardSyncingIds } from './pinCardDrag';
import { createFrameDragFollowSession, membershipIdFromFrameShape } from './frameMembership';

function dragOriginKey(editor) {
  const origin = editor.inputs?.originPagePoint;
  if (!origin || !Number.isFinite(origin.x) || !Number.isFinite(origin.y)) return '';
  return `${origin.x}:${origin.y}`;
}

/**
 * When a frame moves, translate page-level pins that already belong to it.
 * The follower set is fixed at drag start, so the moving frame does not pick up
 * pins it passes over. True frame children already move with the parent.
 * Placement persistence is handled by the board document listener on frame moves.
 */
export function registerFramePinFollow(editor) {
  if (!editor) return () => {};

  const followSession = createFrameDragFollowSession();

  return editor.sideEffects.registerAfterChangeHandler('shape', (prev, next, source) => {
    if (source !== 'user') return;
    if (!prev || !next || prev.type !== 'frame' || next.type !== 'frame') return;
    if (editor.getIsReadonly()) return;

    const dx = next.x - prev.x;
    const dy = next.y - prev.y;
    if (dx === 0 && dy === 0) return;

    const pinIds = followSession.pinIdsForFrameStep(editor, prev, next, {
      isDragging: Boolean(editor.inputs?.isDragging),
      originKey: dragOriginKey(editor),
    });
    if (!pinIds.length) return;

    const membershipId = membershipIdFromFrameShape(next);

    editor.run(() => {
      for (const shapeId of pinIds) {
        const latest = editor.getShape(shapeId);
        if (!latest) continue;
        pinCardSyncingIds.add(latest.id);
        try {
          editor.updateShape({
            id: latest.id,
            type: latest.type,
            x: latest.x + dx,
            y: latest.y + dy,
            meta: {
              ...latest.meta,
              frameId: latest.meta?.frameId || membershipId || null,
            },
          });
        } finally {
          pinCardSyncingIds.delete(latest.id);
        }
      }
    });
  });
}
